import React, { useState, useRef } from 'react'
import './UserReview.css'
import ReactStars from "react-rating-stars-component";
import Swal from 'sweetalert2';
import { SERVER_URL } from '../../../ServerUrl';
import axios from 'axios';
import { useLocation, useHistory, Link } from 'react-router-dom';

const UserReviewWithoutLogin = () => {
    const history = useHistory();
    const fileInputRef = useRef(null);
    const location = useLocation();
    const { bookingId } = location.state || {};
    const [feedbackData, setFeedbackData] = useState({
        punctuality: 0,
        cleanliness: 0,
        comfort: 0,
        staffBehavior: 0,
        valueForMoney: 0,
        overAllExperience: 0,
        title: "",
        review: "",
        userId: '',
        files: null,
    });
    const [selectedFiles, setSelectedFiles] = useState([]);




    const ratingChanged = (field, newRating) => {
        setFeedbackData((prev) => ({
            ...prev,
            [field]: newRating, // Dynamically update the field
        }));
    };
    const handleInputChange = (field, value) => {
        setFeedbackData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0]; // Get the first selected file

        if (file) {
            // Validate file type (PDF, image, or video)
            const allowedTypes = [
                'application/pdf', // PDF
                'image/jpeg', // JPEG images
                'image/png', // PNG images
                'image/gif', // GIF images
                'video/mp4', // MP4 videos
                'video/quicktime', // MOV videos
            ];

            if (!allowedTypes.includes(file.type)) {
                // Show SweetAlert2 error message
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid File Type',
                    text: 'Please select a valid PDF, image (JPEG, PNG, GIF), or video (MP4, MOV).',
                    confirmButtonText: 'OK',
                });
                return;
            }

            // Update the state with the file
            setFeedbackData((prev) => ({
                ...prev,
                file: file, // Store the file object
            }));
        }
    };




    const SaveReview = async () => {
        try {
            const formData = new FormData();

            for (const key in feedbackData) {
                if (key === 'file' && feedbackData[key]) {
                    formData.append(key, feedbackData[key]);
                } else {
                    formData.append(key, feedbackData[key]);
                }
            }

            const response = await axios.post(`${SERVER_URL}/review/${bookingId}`, formData);

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Your review has been saved successfully',
                confirmButtonText: 'OK',
            }).then((result) => {
                if (result.isConfirmed) {
                    history.push('/');
                }
            });
        } catch (err) {
            console.error('Error saving review:', err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while saving your review. Please try again.',
                confirmButtonText: 'OK',
            });
        }
    };


    console.log(feedbackData, "123feedbackData", bookingId)
    return (
        <div className='clientReviewWithout'>
            <div className="pageTittReview">
                <p style={{ textAlign: "center" }}> How was your trip?</p>
            </div >
            <div className='reviewMainSection'>
                <div className='reviewOuter'>
                    <div className='reviewDetailText'><span className='punctsText'>Punctuality:</span>  Did the bus depart and arrive on time?</div>
                    <ReactStars
                        count={5}
                        onChange={(newRating) => ratingChanged("punctuality", newRating)}
                        size={28}
                        activeColor="#C45500"
                        precision={1}
                    />
                </div>
                <div className='reviewOuter'>
                    <div className='reviewDetailText'><span className='punctsText'>Cleanliness:</span> Was the bus clean and well maintained?</div>
                    <ReactStars
                        count={5}
                        onChange={(newRating) => ratingChanged("cleanliness", newRating)}
                        size={28}
                        activeColor="#C45500"
                        precision={1}
                    />
                </div>
                <div className='reviewOuter'>
                    <div className='reviewDetailText'><span className='punctsText'>Comfort:</span> How comfortable were the seats and amenities?</div>
                    <ReactStars
                        count={5}
                        onChange={(newRating) => ratingChanged("comfort", newRating)}
                        size={28}
                        activeColor="#C45500"
                        precision={1}
                    />
                </div>
                <div className='reviewOuter'>
                    <div className='reviewDetailText'><span className='punctsText'>Staff Behavior:</span> Were the staff polite and helpful?</div>
                    <ReactStars
                        count={5}
                        onChange={(newRating) => ratingChanged("staffBehavior", newRating)}
                        size={28}
                        activeColor="#C45500"
                        precision={1}
                    />
                </div>
                <div className='reviewOuter'>
                    <div className='reviewDetailText'><span className='punctsText'>Value for Money:</span> Was the ticket price reasonable?</div>
                    <ReactStars
                        count={5}
                        onChange={(newRating) => ratingChanged("valueForMoney", newRating)}
                        size={28}
                        activeColor="#C45500"
                        precision={1}
                    />
                </div>
                <div className='reviewOuter'>
                    <div className='reviewDetailText'><span className='punctsText'>Overall Experience:</span> General satisfaction with the trip.</div>
                    <ReactStars
                        count={5}
                        onChange={(newRating) => ratingChanged("overAllExperience", newRating)}
                        size={28}
                        activeColor="#C45500"
                        precision={1}
                    />
                </div>
                <div className="reviewMargin">
                    <div className='punctsText'>Title of your review:</div>
                    <input
                        className='reiewTitleInput'
                        placeholder="What's most important to know?"
                        type='text'
                        value={feedbackData.title}
                        onChange={(e) => handleInputChange('title', e.target.value)}
                    />                </div>
                <div className="reviewMargin">
                    <div className='punctsText'>Write a review:</div>
                    <textarea
                        className='reiewTitleTextarea'
                        placeholder="Write your review here..."
                        value={feedbackData.review} // Bind to the review field
                        onChange={(e) => handleInputChange('review', e.target.value)} // Update review
                    ></textarea>
                </div>
                <input
                    type="file"
                    ref={fileInputRef}
                    className="hidden-file-input"
                    onChange={handleFileUpload}
                    accept=".pdf, image/*, video/*"
                />
                <div className="file-upload-section">
                    <button className="attach-button-file" onClick={() => fileInputRef.current.click()}>
                        Attach a PDF, image, or video
                    </button>
                    <div className="file-names">
                        {feedbackData.file ? feedbackData.file.name : "No file selected"}
                    </div>
                </div>
                <button className="submit-button-review" onClick={SaveReview}>Submit</button>
            </div>
        </div>
    )
}

export default UserReviewWithoutLogin
